<template>
    <div class="medal-block">
        <div class="medals">
            <div class="medal bronze" :class="{ won : isType( '3OM,3DR,3LP'  ) }"></div>
            <div class="medal silver" :class="{ won : isType( '2OM,2DR,2LP'  ) }"></div>
            <div class="medal gold"   :class="{ won : isType( 'balanced' ) }"></div>
        </div>
        <div class="label">Your Result<strong>{{medalType}} : {{medalLabel}}</strong></div>
        <p v-html="medalInfo"></p>
    </div>
</template>

<script>
    import slugify from '/src/assets/js/slugify.js'

    export default {
        name : "Medal2",
        props: {
            medalType: String,
            medalKey: String,
            medalLabel: String,
            medalInfo: String
        },
        methods : {
            isType( val ){
                let match = false
                val.split( "," ).forEach( v => {
                    if( slugify( v ) === this.medalKey ){
                        match = true
                    }
                })
                return match
            }
        }
    }
</script>